module.exports = __webpack_public_path__ + "static/media/undraw_wash_hands_nwl2.80d7cc00.svg";